import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

export type FieldMappingField = 'indication' | 'therapeuticArea' | 'genericName' | 'studyType' | 'compoundName'

export interface FieldMapping {
    _id: string
    organizationId: string
    field: FieldMappingField
    primaryValue: string
    synonyms: string[]
    createdBy: string
    createdAt: string
    updatedAt: string
}

const FIVE_MINUTES = 5 * 60 * 1000

export const useGetFieldMappingsQuery = (organizationId: string | undefined) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    return useQuery<FieldMapping[]>(
        ['fieldMappings', organizationId],
        async () => {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const res = await callAPI(
                `${endpoints.getFieldMappings.url}${organizationId}`,
                endpoints.getFieldMappings.method,
                token
            )
            return (res as { data: FieldMapping[] }).data
        },
        {
            enabled: !!organizationId && !!getTokenSilently && !!isAuthenticated && !isLoading,
            staleTime: FIVE_MINUTES,
            refetchOnWindowFocus: false,
        }
    )
}
